import { render, staticRenderFns } from "./odoo-sale-order-invoice-status-select.vue?vue&type=template&id=e48cf5c8&scoped=true&"
import script from "./odoo-sale-order-invoice-status-select.vue?vue&type=script&lang=js&"
export * from "./odoo-sale-order-invoice-status-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48cf5c8",
  null
  
)

export default component.exports